import { TIPTAP_COLLAPSIBLE_LIST_TYPE } from 'ricos-content';
import { findNodeClosestToSelection } from 'ricos-plugins';
import { createShortcut, RicosPluginToolbarNames } from 'ricos-types';
import type { EditorPluginCreator } from 'wix-rich-content-common';

import { DEFAULTS } from './defaults';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import CollapsibleListSettingsModal from './modals/SettingsModals';
import { tiptapExtensions } from './tiptap/tiptap';
import type { CollapsibleListPluginEditorConfig } from './types';
import { COLLAPSIBLE_LIST_TYPE } from './types';

export const pluginCollapsibleList: EditorPluginCreator<
  CollapsibleListPluginEditorConfig,
  { SettingsModal: typeof CollapsibleListSettingsModal }
> = config => {
  const pluginConfig: CollapsibleListPluginEditorConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: COLLAPSIBLE_LIST_TYPE,
    tiptapExtensions,
    getAddButtons,
    toolbar: {
      names: [RicosPluginToolbarNames.COLLAPSIBLE_LIST],
      getButtons: getToolbarButtons,
      isVisible: (_, { adapter: { tiptapEditor } }) => {
        return findNodeClosestToSelection(tiptapEditor, TIPTAP_COLLAPSIBLE_LIST_TYPE) !== null;
      },
      resolveReferenceElement: tiptapEditor => {
        return (
          findNodeClosestToSelection(tiptapEditor, TIPTAP_COLLAPSIBLE_LIST_TYPE)?.element ?? null
        );
      },
    },
    shortcuts: [
      createShortcut({
        name: 'MoveToNextElementTab',
        description: 'ShortcutsSheet_CollapsibleList_MoveToNextElement',
        group: 'ShortcutsSheet_Section_CollapsibleList',
        keys: {
          macOs: 'Tab',
          windows: 'Tab',
        },
        enabled: false,
        command: () => {},
      }),
      createShortcut({
        name: 'MoveToNextElementEnter',
        description: 'ShortcutsSheet_CollapsibleList_MoveToNextElement',
        group: 'ShortcutsSheet_Section_CollapsibleList',
        keys: {
          macOs: 'Enter',
          windows: 'Enter',
        },
        enabled: false,
        command: () => {},
      }),
      createShortcut({
        name: 'SelectEntireList',
        description: 'ShortcutsSheet_CollapsibleList_SelectTheEntireList',
        group: 'ShortcutsSheet_Section_CollapsibleList',
        keys: {
          macOs: 'Meta+A',
          windows: 'Ctrl+A',
        },
        enabled: false,
        command: () => {},
      }),
    ],
    __exports: {
      SettingsModal: CollapsibleListSettingsModal,
    },
  };
};
